export const IS_IT_DOWN_URL = 'https://is-it-down.amazon.com/ACS-Infra';
export const IS_IT_DOWN_API = `${IS_IT_DOWN_URL}/components/21594.js`;
